//@ts-check
import React from 'react';
import Typography from '@material-ui/core/Typography';
import Tooltip from '@material-ui/core/Tooltip';
import withWidth, { isWidthDown } from '@material-ui/core/withWidth';
import withManifest from '../../../apps/manifest/withManifest';
/**
 *
 * @param { { width: any } & import('core/EcrionProvider/types').WithManifest} props
 */

var Copyright = function Copyright(_ref) {
  var width = _ref.width,
      manifest = _ref.manifest;
  var year = new Date().getFullYear();
  var children = null;
  var version = '';
  if (manifest && manifest.Version) version = manifest.Version;
  children = "Copyright ".concat(year, " \xA9 MHC Automation / All rights reserved");
  var text = React.createElement(Typography, {
    color: "#627383",
    style: {
      position: 'relative',
      bottom: 0,
      marginBottom: 8,
      marginTop: 8,
      textAlign: 'center',
      left: 0,
      right: 0
    }
  }, children);

  if (version) {
    var app = manifest ? manifest.Name : '';
    return React.createElement("div", {
      style: {
        textAlign: 'center'
      }
    }, React.createElement("div", {
      style: {
        display: 'inline-flex'
      }
    }, React.createElement(Tooltip, {
      title: "".concat(app, " version ").concat(version)
    }, text)));
  }

  return text;
};

export default withWidth()(withManifest(Copyright));